import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../auth/auth.api";
import { TSuccessResponse } from "@/types/general/TSuccessResponse";
import TKRA from "@/types/kra-management/TKRA";
import TPaginationParams from "@/types/general/TPaginationParams";

export const teamApi = createApi({
  reducerPath: "teamApi",
  tagTypes: ["TEAM"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllTeam: builder.query<
      TSuccessResponse<any[]>,
      { pagination?: TPaginationParams; searchKey?: string }
    >({
      query: ({ pagination = {} as any, searchKey }) => {
        const params: Record<any, any> = {};
        const { page = 1, limit = 100 } = pagination;

        if (page && limit) {
          params.page = page;
          params.limit = limit;
        }

        if (searchKey) {
          params.search = searchKey;
        }

        return {
          url: "team-management/team",
          params: params,
        };
      },
    }),

    createTeam: builder.mutation<TSuccessResponse<null>, any>({
      query: (body) => ({
        url: "team-management/team",
        method: "POST",
        body,
      }),
    }),

    updateTeam: builder.mutation<
      TSuccessResponse<null>,
      { id: number; data: any }
    >({
      query: ({ id, data }) => ({
        url: `team-management/team/update/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getEditTeam: builder.query<
      TSuccessResponse<any>, // replace with actual type
      number | string
    >({
      query: (id) => ({
        url: `team-management/team/edit/${id}`,
        method: "GET",
      }),
    }),

    deleteTeam: builder.mutation<
      TSuccessResponse<null>,
      {
        id: string | number;
      }
    >({
      query: ({ id }) => ({
        url: `team-management/team/${id}`,
        method: "DELETE",
      }),
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllTeamQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useGetEditTeamQuery,
  useDeleteTeamMutation,
} = teamApi;
